import axiosInstance from '../api/axios';

export interface GeoEmergencyAffectedCounts {
  merchant_rates: number;
  traders: number;
}

export interface GeoEmergencySwitch {
  id: string;
  country: {
    id: string;
    name: string;
    iso_code: string;
  };
  is_blocked: boolean;
  blocked_at: string | null;
  blocked_by: {
    id: string;
    email: string;
    username: string;
  } | null;
  reason: string | null;
  affected: GeoEmergencyAffectedCounts;
  has_snapshot: boolean;
}

export const geoEmergencyService = {
  list: async (): Promise<GeoEmergencySwitch[]> => {
    const response = await axiosInstance.get('/geo-emergency/');
    return response.data;
  },

  block: async (countryId: string, reason: string): Promise<GeoEmergencySwitch> => {
    const response = await axiosInstance.post(`/geo-emergency/${countryId}/block`, {
      reason,
      confirm: true,
    });
    return response.data;
  },

  unblock: async (countryId: string): Promise<GeoEmergencySwitch> => {
    const response = await axiosInstance.post(`/geo-emergency/${countryId}/unblock`);
    return response.data;
  },
};
